import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const toolkitApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
    }),
    endpoints: (build) => ({}),
}) as any;

export const toolkitSimpleTransform = ({ data }) => data;

export default toolkitApi;
